import { memo } from "react";
import { Outlet } from "react-router";

export const EmptyLayout = memo(() => {
  return <Outlet />;
});
